module.exports = __webpack_public_path__ + "static/5-ba3f3e3c72a01c37b185141e4bd7ed54.jpg";